let axios = require('axios')
if (!axios.create) {
    axios = axios.default
}

const REQUEST_TTL = 4000;// 4 seconds

let NsLoyalty = class NsLoyalty {

    constructor (constructorObject) {
        this.market = constructorObject.market;
        this.userId = constructorObject.userId;
        this.jwt = constructorObject.jwt;
        this.client_id = constructorObject.client_id;
        this.client_secret = constructorObject.client_secret;
        this.ongoingGraphQLCalls = {};
        this.requestConfig = {
            headers: {
                "Authorization": this.jwt,
                "client_id": this.client_id,
                "client_secret": this.client_secret
            }
        };
        this.requestUrl = constructorObject.requestUrl + '/loyalty-graphql/';
        this.requestAdrOptInStatusUrl = constructorObject.requestUrl + '/loyalty-adr-convert/v1/'
        this.requestApiVersion = 'v1';
        this.proxyRequestUrl = constructorObject.requestUrl + '/annex-cloud-proxy/' + this.requestApiVersion + '/' + this.market;

        this.resetLoyaltyObject();
    }

    adjustWithRunningTotal(creditActivity, runningTotal) {
        if (runningTotal > creditActivity) {
            return creditActivity
        } else {
            return runningTotal
        }
    }

    adjustWithinSevenToConsiderPartialCreditAvailability(totalToAdjustBy) {
        let sortedArray = this.sort('expireDate', this.buckets.withinSeven);
        sortedArray[0].credit += totalToAdjustBy;
        this.buckets.withinSeven = sortedArray;
    }

    filterOutNetZeroOrders(activityDetail) {
        const orders = {}
        activityDetail.forEach((activity) => {
            const orderId = activity.orderId
            if (!orders[orderId]) {
                orders[orderId] = 0
            }
            if (activity.debit) {
                orders[orderId] -= activity.debit
            } else if (activity.credit) {
                orders[orderId] += activity.credit
            }
        })
        const ordersToRemove = []
        for (const [key, value] of Object.entries(orders)) {
            if (value === 0) {
                ordersToRemove.push(key)
            }
        }
        const filteredActivityDetail = activityDetail.filter(element => !ordersToRemove.includes(element.orderId))
        return filteredActivityDetail
    }

    buildOutBuckets(activityDetail, runningTotal, returnedItems) {
        this.buckets = {
            withinSeven: [],
            withinThirty: 0,
            longTerm: 0,
            nonExpiring: 0
        };

        const filteredActivityDetail = this.filterOutNetZeroOrders(activityDetail)
        filteredActivityDetail.forEach((activity) => {
            let dateDiff = activity.expireDate ? this.calculateDayDifference(activity.expireDate) : 3650;
            if(activity.credit && runningTotal > 0 && dateDiff >= 0) {
                if(dateDiff === 3650) {
                    this.buckets.nonExpiring += this.adjustWithRunningTotal(this.calculateCredit(activity, returnedItems), runningTotal);
                } else if(dateDiff > 30) {
                    this.buckets.longTerm += this.adjustWithRunningTotal(this.calculateCredit(activity, returnedItems), runningTotal);
                } else if(dateDiff > 7) {
                    this.buckets.withinThirty += this.adjustWithRunningTotal(this.calculateCredit(activity, returnedItems), runningTotal);
                } else {
                    this.buckets.withinSeven.push(this.getWithinSevenActivityWithReturnsCalculated(activity, returnedItems));
                }
                runningTotal -= this.calculateCredit(activity, returnedItems);
            }
        });
        return runningTotal;
    }

    calculateCredit(activity, returnedItems) {
        if(activity.orderId){
            if('order_' + activity.orderId.toString() in returnedItems){
                return activity.credit - returnedItems['order_' + activity.orderId.toString()].returnValue;
            } else {
                return activity.credit;
            }
        }
        return activity.credit;
    }

    calculateDayDifference(isoDateStr) {
        const DAY_IN_MILLIS = 1000 * 86400
        let now = new Date()
        now.setUTCHours(0,0,0,0)

        let expireDate = new Date(isoDateStr)
        expireDate.setUTCHours(0,0,0,0)
    
        return (expireDate.getTime() - now.getTime()) / DAY_IN_MILLIS
    }

    createActivityArray(activityArray){
        let activity = [];
        activityArray.forEach((item) => {
            activity.push(Object.assign({}, item));
        });
        return activity;
    }

    createAndSetBucketsFromActivity(graphResponse) {
        if(!graphResponse.user){
            return false;
        }
        let runningTotal = graphResponse.user.points.availablePoints;
        let returnedItems = this.identifyReturnedOrders(graphResponse.user.activity.activityDetail);

        runningTotal = this.buildOutBuckets(graphResponse.user.activity.activityDetail, runningTotal, returnedItems);

        if(this.buckets.withinSeven.length && runningTotal < 0) {
            this.adjustWithinSevenToConsiderPartialCreditAvailability(runningTotal);
        } else {
            let sortedArray = this.sort('expireDate', this.buckets.withinSeven);
            this.buckets.withinSeven = sortedArray;
        }
        return true;
    }

    createQueryString(requestObjects) {
        let queryString = `{`;

        if(this.userId){
            queryString += `
        user(accountId: "${this.userId}", market: "${this.market}") {
          adrConversionOptInViewedStatus
          optInStatus
          entityType
          adrParticipant
          titleParticipant
          birthDate
          anniversaryDate
          optInDate
          totalSpendCurrency
      `;
            if(requestObjects.tier){
                queryString += `
          tier {
            currentTier
            nextTier
            purchaseRatio
            pointsToNextTier
            completedLimitPoints
            currentTierPurchaseRatio
            maximumLimitPoints
            pendingLimitPoints
            previousTier
            spendAmountToNextTier
            tierLimitReachedFlag
            tierLimitReachedStatus
          }
        `
            }
            if(requestObjects.activity){
                queryString += `
          activity {
            pages
            activityCount
            activityDetail {
              actionId
              activity
              credit
              debit
              displayText
              orderId
              createDate
              expireDate
            }
          }
        `
            }
            if(requestObjects.points){
                queryString += `
          points {
            availablePoints
            totalSpent
            usedPoints
            expiredPoints
            lifetimePoints
            spendToNextTier
            pointsToExpire
            pointsToExpireDate
          }
        `
            }
            queryString += `}`;
        }
        if(requestObjects.marketConfig){
            queryString += `
      marketConfig(market: "${this.market}") {
        titleParticipant
        tierConfig {
          name
          purchaseIncrement
          minSpend
          purchaseRatio
          redemptionLimit
          daysToExpire
          spendWithinPeriod
          tierThreshold
          tierMonthlyEarningCap
        }
        entityTypes {
          cust
          pref
          dist
        }
      }
      `
        }
        queryString += `}`
        return queryString;
    }

    async getAllLoyaltyInfo() {
        this.resetLoyaltyObject();
        let queryString = this.createQueryString({tier: true, activity: true, points: true, marketConfig: true})

        await this.makeGraphCall(queryString).then(graphResponse => {
            this.activity = graphResponse.user ? this.createActivityArray(graphResponse.user.activity.activityDetail) : [];
            this.createAndSetBucketsFromActivity(graphResponse);
            this.setCurrentTierData(graphResponse);
            this.setEntityType(graphResponse);
            this.setSoonestToExpire(graphResponse);
            this.setStatus(graphResponse);
            this.setTierData(graphResponse);
            this.setTitleParticipant(graphResponse);
            this.setUser(graphResponse);
            this.setWallet(graphResponse);
        });

        return {
            activity: this.activity,
            buckets: this.buckets,
            entityType: this.entityType,
            optInStatus: this.status,
            soonestExpiring: this.soonestExpiring,
            tierData: this.tierData,
            titleParticipant: this.titleParticipant,
            user: this.user,
            userTier: this.currentTierData,
            wallet: this.wallet
        }
    }

    async getMarketConfig() {
        this.resetLoyaltyObject();

        await this.makeGraphCall(this.createQueryString({marketConfig:true})).then(graphResponse => {
            this.setStatus(graphResponse);
            this.setTitleParticipant(graphResponse);
            this.setTierData(graphResponse);
            this.setEntityTypes(graphResponse);
        });

        return {
            optInStatus: this.status,
            tierData: this.tierData,
            titleParticipant: this.titleParticipant,
            entityTypes: this.entityTypes
        }
    }

    async getRewardsBucketsAndCurrentTierData() {
        this.resetLoyaltyObject();

        await this.makeGraphCall(this.createQueryString({tier: true, activity: true, points: true, marketConfig: true})).then(graphResponse => {
            this.createAndSetBucketsFromActivity(graphResponse);
            this.setCurrentTierData(graphResponse);
            this.setSoonestToExpire(graphResponse);
            this.setStatus(graphResponse);
            this.setUser(graphResponse);
            this.setWallet(graphResponse);
        });

        return {
            buckets: this.buckets,
            optInStatus: this.status,
            soonestExpiring: this.soonestExpiring,
            user: this.user,
            userTier: this.currentTierData,
            wallet: this.wallet
        }
    }

    async getUserOptInStatus() {
        this.resetLoyaltyObject();

        await this.makeGraphCall(this.createQueryString({})).then(graphResponse => {
            this.setStatus(graphResponse);
            this.setUser(graphResponse);
        });

        return {
            optInStatus: this.status,
            user: this.user
        }
    }

    async getViewedTandC() {
        let axiosResponse = await axios.get(`${this.requestAdrOptInStatusUrl}${this.userId}`, this.requestConfig)
        return {
            viewed_tc: axiosResponse.data.data.viewed_tc
        }
    }

    async getWalletAndSoonestToExpire() {
        this.resetLoyaltyObject();

        await this.makeGraphCall(this.createQueryString({activity: true, points: true})).then(graphResponse => {
            this.setSoonestToExpire(graphResponse);
            this.setStatus(graphResponse);
            this.setUser(graphResponse);
            this.setWallet(graphResponse);
        });

        return {
            optInStatus: this.status,
            soonestExpiring: this.soonestExpiring,
            user: this.user,
            wallet: this.wallet
        }
    }

    getWithinSevenActivityWithReturnsCalculated(activity, returnedItems) {
        if(activity.orderId){
            if('order_' + activity.orderId.toString() in returnedItems){
                activity.credit = this.calculateCredit(activity, returnedItems);
            }
        }

        //We also need to calculate how many days until it expires:
        activity.expiresInDays = this.calculateDayDifference(activity.expireDate)

        return activity;
    }

    identifyReturnedOrders(activityDetail) {
        let returnedItems = [];

        activityDetail.forEach((activity) => {
            if(activity.actionId === 148 && activity.orderId) {
                let orderArray = {}
                if('order_' + activity.orderId.toString() in returnedItems){
                    orderArray = returnedItems['order_' + activity.orderId];
                    orderArray.returnValue = orderArray.returnValue + activity.debit;
                } else {
                    orderArray = {
                        orderId: activity.orderId,
                        returnValue: activity.debit
                    }
                }
                returnedItems['order_' + activity.orderId.toString()] = orderArray;
            }
        });

        return returnedItems;
    }

    async makeGraphCall(queryString) {
        let createdRequest = false;
        let result = null;
        try {
            let request = this.ongoingGraphQLCalls[queryString];
            if (!request) {
                request = axios.post(this.requestUrl, queryString, this.requestConfig);
                this.ongoingGraphQLCalls[queryString] = request;
                createdRequest = true;
            }

            let axiosResponse = await request;
            result = this.orderActivity(axiosResponse.data);
        } catch (error) {
            console.error('There is an error connecting to the GraphQL Proxy. Here is the error response: ', error);
        }

        if (createdRequest) {
            setTimeout(() => {
                this.ongoingGraphQLCalls[queryString] = undefined;
            }, REQUEST_TTL);
        }

        return result;
    }

    optInConfirmFromRequestResponse(responseObject) {
        if(!responseObject.id || !responseObject.optInStatus || responseObject.optInStatus !== 'YES'){
            return false;
        }

        return true;
    }

    async optInCreateUser(userDetailsObject) {
        let requestObject = {
            id: this.userId,
            firstName: userDetailsObject.firstName || '',
            lastName: userDetailsObject.lastName || '',
            extendedAttribute: {
                adrParticipant: userDetailsObject.adrParticipant,
                titleParticipant: userDetailsObject.titleParticipant,
                entityType: userDetailsObject.entityType
            }
        }
        try{
            let axiosResponse = await axios.post(this.proxyRequestUrl + '/users', requestObject, this.requestConfig);
            return this.optInConfirmFromRequestResponse(axiosResponse.data);
        } catch (error) {
            console.error({error});
        }
    }

    async optInExistingUser(userDetailsObject) {
        let requestObject = {
            id: this.userId,
            optInStatus: 'YES',
            firstName: userDetailsObject.firstName || '',
            lastName: userDetailsObject.lastName || '',
            extendedAttribute: {
                adrParticipant: userDetailsObject.adrParticipant,
                titleParticipant: userDetailsObject.titleParticipant,
                entityType: userDetailsObject.entityType || ''
            }
        }

        try {
            let axiosResponse = await axios.patch(this.proxyRequestUrl + '/users/' + this.userId, requestObject, this.requestConfig);
            return this.optInConfirmFromRequestResponse(axiosResponse.data);
        } catch (error) {
            console.error({error});
        }
    }

    async optInUser(userDetailsObject) {
        if(!userDetailsObject.adrParticipant || !userDetailsObject.titleParticipant){
            return false;
        }

        //We need to first check if they already have an account:
        let userOptedIn = await this.getUserOptInStatus();
    
        if(!userOptedIn.user) {
            return await this.optInCreateUser(userDetailsObject);
        } else {
            if(userOptedIn.optInStatus){
                if(userDetailsObject.titleParticipant != userOptedIn.user.titleParticipant
          || userDetailsObject.adrParticipant != userOptedIn.user.adrParticipant
          || userDetailsObject.entityType != userOptedIn.user.entityType){
                    return await this.optInExistingUser(userDetailsObject);
                }
                return true;
            } else {
                return await this.optInExistingUser(userDetailsObject);
            }
        }
    }

    optOutConfirmFromRequestResponse(responseObject) {
        if(!responseObject.id || !responseObject.optInStatus || responseObject.optInStatus !== 'NO'){
            return false;
        }

        return true;
    }

    async optOutUser() {
        let requestObject = {
            id: this.userId,
            optInStatus: 'NO'
        }

        try{
            let axiosResponse = await axios.patch(this.proxyRequestUrl + '/users/' + this.userId, requestObject, this.requestConfig);
            return this.optOutConfirmFromRequestResponse(axiosResponse.data);
        } catch (error) {
            console.error({error});
        }
    }

    orderActivity(graphResponse) {
        if(graphResponse.user && graphResponse.user.activity && graphResponse.user.activity.activityDetail) {
            graphResponse.user.activity.activityDetail = this.reverseSort('createDate', graphResponse.user.activity.activityDetail)
        }
        return graphResponse
    }

    resetLoyaltyObject() {
        this.activity = [];

        this.buckets = {
            withinSeven: [],
            withinThirty: 0,
            longTerm: 0,
            nonExpiring: 0
        };

        this.currentTierData = {
            name: false,
            purchaseIncrement: 0,
            minSpend: 0,
            purchaseRatio: 0,
            redemptionLimit: 0,
            daysToExpire: 0
        };

        this.soonestExpiring = {
            pointsToExpire: 0,
            expirationDate: new Date()
        };

        this.status = false;

        this.tierData = [];

        this.titleParticipant = false;

        this.user = false;

        this.wallet = {
            available: 0,
            spent: 0,
            spentInPeriod: 0,
            expired: 0,
            lifetimePointsEarned: 0
        };
    }

    reverseSort(prop, arr) {
        prop = prop.split('.');
        let len = prop.length;

        arr.sort(function (b, a) {
            let i = 0;
            while(i < len) {
                a = a[prop[i]];
                b = b[prop[i]];
                i++;
            }
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            } else {
                return 0;
            }
        });
        return arr;
    }

    setCurrentTierData(graphResponse) {
        if(!graphResponse.user) {
            return false;
        }
        //Define the current tier of the user in question:
        let userCurrentTier = graphResponse.user.tier.currentTier;
        //Iterate through the market data to get the info for the tier they belong to:
        graphResponse.marketConfig.tierConfig.forEach((tierData) => {
            if(tierData.name === userCurrentTier) {
                this.currentTierData = tierData;
            }
        });

        return true;
    }

    setEntityType(graphResponse) {
        if(graphResponse.user) {
            this.entityType = graphResponse.user.entityType;
        }
    }

    setEntityTypes(graphResponse) {
        let rv = false
        if(graphResponse.marketConfig && graphResponse.marketConfig.entityTypes) {
            this.entityTypes = graphResponse.marketConfig.entityTypes
            rv = true
        } 

        return rv;
    }

    setSoonestToExpire(graphResponse) {
        if(!graphResponse.user) {
            return false;
        }
        this.soonestExpiring.pointsToExpire = graphResponse.user.points.pointsToExpire;
        this.soonestExpiring.expirationDate = graphResponse.user.points.pointsToExpireDate;

        return true;
    }

    setStatus(graphResponse) {
        if(graphResponse.user && graphResponse.user.optInStatus === 'YES'){
            this.status = true;
        } else {
            this.status = false;
        }
    }

    setTierData(graphResponse) {
        if(!graphResponse.marketConfig) {
            return false;
        } else {
            this.tierData = [];
        }
        graphResponse.marketConfig.tierConfig.forEach((market) => {
            this.tierData.push(market)
        });

        return true;
    }

    setTitleParticipant(graphResponse) {
        if(!graphResponse.marketConfig) {
            return false;
        }

        this.titleParticipant = graphResponse.marketConfig.titleParticipant;

        return true;
    }

    setUser(graphResponse) {
        this.user = graphResponse.user || false;
    }

    async setUserViewedTandC() {
        let axiosResponse = await axios.delete(`${this.requestAdrOptInStatusUrl}${this.userId}`, this.requestConfig)
        return {
            success: axiosResponse.data.data.success
        }
    }

    setWallet(graphResponse) {
        if(!graphResponse.user) {
            return false;
        }
        this.wallet.available = graphResponse.user.points.availablePoints;
        this.wallet.spent = this.tallySpentPoints(graphResponse.user);
        this.wallet.spentInPeriod = graphResponse.user.points.totalSpent;
        this.wallet.expired = graphResponse.user.points.expiredPoints;
        this.wallet.lifetimePointsEarned = graphResponse.user.points.lifetimePoints;

        return true;
    }

    sort(prop, arr) {
        prop = prop.split('.');
        let len = prop.length;

        arr.sort(function (a, b) {
            let i = 0;
            while(i < len) {
                a = a[prop[i]];
                b = b[prop[i]];
                i++;
            }
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            } else {
                return 0;
            }
        });
        return arr;
    }

    tallySpentPoints(graphResponseUser) {
        let totalSpent = 0;

        graphResponseUser.activity.activityDetail.forEach((activity) => {
            if(activity.actionId === 107) {
                totalSpent += activity.debit;
            }
        })

        return totalSpent;
    }

}

module.exports = {
    NsLoyalty: NsLoyalty
}
